import { Nominal } from './nominal';

export type Version = Nominal<string, 'XAPIVersion'>;

export const version1 = (): Version => <Version>'1.0.0';
